import { httpPatch, httpPost } from '../http/actions'
import {
  GET_PARTICIPANTS,
  GET_PARTICIPANTS_SUCCESS,
  GET_PARTICIPANTS_FAILURE,
  ADD_PARTICIPANT,
  ADD_PARTICIPANT_FAILURE,
  ADD_PARTICIPANT_SUCCESS,
  UPDATE_PARTICIPANT,
  UPDATE_PARTICIPANT_SUCCESS,
  UPDATE_PARTICIPANT_FAILURE,
  GET_PARTICIPANTS_LIST_MORE,
  GET_PARTICIPANTS_LIST_MORE_SUCCESS,
  GET_PARTICIPANTS_LIST_MORE_FAILURE,
} from './constants'

import { axiosHTTP } from '../../utils'
import { removeNull } from '../../utils/utils'

const polarisApi = process.env.REACT_APP_POLARIS_MS_URL

let CancelToken = axiosHTTP.CancelToken
let cancel
export default (store) => (next) => (action) => {
  // GET PARTICIPANTS
  if (action.type === GET_PARTICIPANTS) {
    // cancel the request
    if (cancel != undefined) {
      cancel()
    }

    const {
      participants: { filter },
    } = store.getState()

    store.dispatch(
      httpPost({
        endPoint: `${polarisApi}participants/query`,
        data: removeNull(filter),
        cancelToken: new CancelToken(function executor(b) {
          // An executor function receives a cancel function as a parameter
          cancel = b
        }),
        success: GET_PARTICIPANTS_SUCCESS,
        failure: GET_PARTICIPANTS_FAILURE,
      })
    )
  }

  if (action.type === GET_PARTICIPANTS_LIST_MORE) {
    // cancel the request
    if (cancel != undefined) {
      cancel()
    }
    const {
      participants: { filter },
    } = store.getState()

    store.dispatch(
      httpPost({
        endPoint: `${polarisApi}participants/query`,
        data: removeNull(filter),
        cancelToken: new CancelToken(function executor(c) {
          // An executor function receives a cancel function as a parameter
          cancel = c
        }),
        success: GET_PARTICIPANTS_LIST_MORE_SUCCESS,
        failure: GET_PARTICIPANTS_LIST_MORE_FAILURE,
      })
    )
  }

  if (action.type === ADD_PARTICIPANT) {
    const { participant } = action.payload
    store.dispatch(
      httpPost({
        endPoint: `${polarisApi}participants`,
        data: participant,
        success: ADD_PARTICIPANT_SUCCESS,
        failure: ADD_PARTICIPANT_FAILURE,
      })
    )
  }

  if (action.type === UPDATE_PARTICIPANT) {
    const { newParticipant, id } = action.payload
    store.dispatch(
      httpPatch({
        endPoint: `${polarisApi}participants/${id}`,
        data: newParticipant,
        success: UPDATE_PARTICIPANT_SUCCESS,
        failure: UPDATE_PARTICIPANT_FAILURE,
      })
    )
  }

  next(action)
}
